import { CUSTOMER_TYPE, KYC_PROFILE } from 'components/common/constants';

// Names of the customers in the Header's customer dropdown (and the single-customer name beside it).

// TRN-7600 — the label of a customer without a name yet (a freshly created "empty" customer has no company_name /
// common_name until KYC / KYB completes). The customer type alone is not enough: a Self-Employed customer is a
// CORPORATE one and a Company Member an INDIVIDUAL one, so the KYC profile (`kycProfile` of the user_accounts item of
// GET /user) decides for those two; Individual and Corporate stay as they were.
const KYC_PROFILE_LABEL_KEYS = {
  [KYC_PROFILE.SELF_EMPLOYED]: 'header.account.type.selfEmployed',
  [KYC_PROFILE.COMPANY_MEMBER]: 'header.account.type.companyMember'
};

const TYPE_LABEL_KEYS = {
  [CUSTOMER_TYPE.COMPANY]: 'registration.accountType.corporate.title',
  [CUSTOMER_TYPE.INDIVIDUAL]: 'registration.accountType.individual.title'
};

export const getAccountTypeLabel = (account, i18n) => {
  const key = KYC_PROFILE_LABEL_KEYS[account?.kycProfile] || TYPE_LABEL_KEYS[account?.type];

  return key ? i18n.getMessage(key) : '';
};

// The only "does this account have a real name" check — shared by getAccountName's own fallback decision and
// getAccountOptions' unnamed-index counting, so the two can never drift apart.
export const resolveAccountName = (account) => {
  if (!account) {
    return '';
  }
  return account.customer_account
    ? account.customer_account.company_name ||
        [account.customer_account.first_name, account.customer_account.last_name].filter(Boolean).join(' ')
    : account.common_name;
};

// TRN-7388's "create an empty customer, verify later" flow means a freshly-registered corporate/individual customer has
// no company_name/common_name until KYC/KYB completes — falls back to "<type label> <n>" (n = order among the
// unnamed accounts with the same label) so the dropdown never renders a blank row, and multiple unverified customers
// of the same kind stay distinguishable from each other.
export const getAccountName = (account, i18n, unnamedIndex) => {
  const name = resolveAccountName(account);
  if (name || !account) {
    return name;
  }

  return [getAccountTypeLabel(account, i18n), unnamedIndex].filter(Boolean).join(' ');
};

// { key, value } options of the dropdown. The order number is counted per label, so "Corporate Account 1" and
// "Corporate Account (Self-Employed) 1" don't share one counter.
export const getAccountOptions = (accounts = [], i18n) => {
  const unnamedCountByLabel = {};

  return accounts.map((account) => {
    let unnamedIndex;
    if (!resolveAccountName(account)) {
      const label = getAccountTypeLabel(account, i18n);
      unnamedCountByLabel[label] = (unnamedCountByLabel[label] || 0) + 1;
      unnamedIndex = unnamedCountByLabel[label];
    }

    return {
      key: account?.customer_account ? account?.customer_account?.account_number : account?.account_number,
      value: getAccountName(account, i18n, unnamedIndex)
    };
  });
};
